import { render, staticRenderFns } from "./ArenaUserList.vue?vue&type=template&id=680147a2"
import script from "./ArenaUserList.vue?vue&type=script&lang=js"
export * from "./ArenaUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports